import { create } from 'zustand';
import type { DashboardOverview, ModbusSnapshot } from '../types/device';
import * as deviceService from '../services/deviceService';
import type { MaintenanceInfo } from '../services/deviceService';
import { getApiErrorMessage } from '../utils/errorMessage';

interface DeviceState {
  overview: DashboardOverview | null;
  modbusSnapshot: ModbusSnapshot | null;
  loading: boolean;
  error: string | null;
  maintenanceDevices: Record<string, MaintenanceInfo>;
  fetchOverview: () => Promise<void>;
  setModbusSnapshot: (snapshot: ModbusSnapshot) => void;
  fetchMaintenance: () => Promise<void>;
  setMaintenanceDevices: (d: Record<string, MaintenanceInfo>) => void;
}

const useDeviceStore = create<DeviceState>((set) => ({
  overview: null,
  modbusSnapshot: null,
  loading: false,
  error: null,
  maintenanceDevices: {},

  fetchOverview: async () => {
    set({ loading: true, error: null });
    try {
      const data = await deviceService.getDashboardOverview();
      set({ overview: data, loading: false });
    } catch (e) {
      set({ error: getApiErrorMessage(e), loading: false });
    }
  },

  setModbusSnapshot: (snapshot) => set({ modbusSnapshot: snapshot }),

  fetchMaintenance: async () => {
    try {
      const data = await deviceService.getDeviceMaintenance();
      set({ maintenanceDevices: data });
    } catch {
      // 靜默失敗，不影響主要功能
    }
  },

  setMaintenanceDevices: (d) => set({ maintenanceDevices: d }),
}));

export default useDeviceStore;
